import m from "./../../../dist/es2015/themes/Klegend.js";
export const am5themes_Klegend = m;